import CustomBottomSheet from 'components/bottomSheet';
import FormikInput from 'components/formikFields/input';
import FormikInputGroup from 'components/formikFields/inputGroup';
import {useEffect, useState} from 'react';
import Num2persian from 'utilities/helper/convertNumToPersian';
import {durationUnits} from 'utilities/helper/durationUnitsOption';
import useGetGradeQuestions from 'utilities/hooks/grade/get/useGetGradeQuestions';
import Grade from '../simple/grade';
import useSetGradeAnswers from 'pages/farm/createAd/form/hooks/useSetGradeAnswers';
import Quality from 'assets/images/grade/quality.svg';
import {qualityConvertor} from 'utilities/helper/quality';
import classNames from 'classnames';
import DotsLoading from 'components/loadings/dotsLoading';

const AuctionFormComponent = ({
  values,
  isLoading,
  subProduct,
  handleAnswers,
  answers,
  isChecked,
  setIsChecked,
}: IAuctionFormComponentProps) => {
  const [isOpenGrade, setIsOpenGrade] = useState<boolean>(false);
  const [isOpenGradeAnswer, setIsOpenGradeAnswer] = useState<boolean>(false);
  const [questions, setQuestions] = useState<IGetGradeQuestions[]>([]);
  const [isOpenGradeQuestions, setIsOpenGradeQuestions] =
    useState<boolean>(false);
  const {gradeQuestions} = useGetGradeQuestions(
    setQuestions,
    setIsOpenGradeQuestions,
  );
  const [grade, setGrade] = useState<number>(0);
  const {gradeMutate, isLoading: GradeIsLoading} = useSetGradeAnswers(
    setIsOpenGrade,
    setIsOpenGradeAnswer,
    setGrade,
  );
  const handleGradeAnswer = () => {
    setIsOpenGrade(false);
    setIsOpenGradeAnswer(true);
    const answersGuid: string[] = [];
    if (answers.length > 0) {
      answers.map(item => answersGuid.push(item.guid));
    }
    gradeMutate({
      subproduct: subProduct ? subProduct : '',
      answers: answersGuid.toString(),
    });
  };
  useEffect(() => {
    if (isChecked) {
      gradeQuestions(subProduct ? subProduct : '');
    }
  }, [isChecked, gradeQuestions, subProduct]);
  return (
    <>
      <div className="mt-6">
        <FormikInput
          label="قیمت پایه*"
          name="price"
          type="number"
          secondaryTitle="تومان"
        />
        {values.price && (
          <div className="flex my-2 text-sm">
            <span className=" ml-1 icon-information text-blue-1 mt-1 "></span>
            <small className=" text-blue-1">
              {Num2persian(values.price?.toString())} تومان
            </small>
          </div>
        )}
      </div>
      <div className="mt-6">
        <FormikInputGroup
          name="duration"
          label="مدت زمان مزایده*"
          Options={durationUnits}
          optionName="duration_unit"
        />
      </div>

      <div className=" flex justify-between">
        <div className="mt-6 flex">
          <label>
            <input
              type="checkbox"
              className="mx-2"
              checked={isChecked}
              onChange={() => {
                if (!isChecked) {
                  setIsChecked(!isChecked);
                  setIsOpenGrade(!isOpenGrade);
                } else {
                  setIsChecked(false);
                }
              }}
            />
            تعیین سطح کیفیت محصول
          </label>
        </div>
        {isChecked && grade > 0 && (
          <p
            className={classNames(
              ' mt-6 py-0.5 px-2 rounded-full',
              Number(grade) === 1 && ' bg-warning-1 text-warning-2',
              Number(grade) === 2 && ' bg-natural-3 text-natural-4',
              Number(grade) === 3 && ' bg-error-1 text-warning-2',
              Number(grade) > 3 && ' bg-Cyan-chat-6 text-green-grade',
            )}
          >
            درجه {grade}
          </p>
        )}
      </div>

      <div className="mt-8">
        <button
          type="submit"
          className=" w-full text-white bg-primary py-4 rounded-lg mb-6"
          disabled={isLoading}
        >
          {GradeIsLoading || isLoading ? (
            <DotsLoading extraStyleCircle="!bg-white !text-white" />
          ) : (
            'ثبت آگهی'
          )}
        </button>
      </div>
      {isOpenGradeQuestions && (
        <CustomBottomSheet
          isOpen={isOpenGrade}
          onDismiss={() => {
            setIsChecked(false);
            setIsOpenGrade(false);
          }}
          questions={true}
        >
          <>
            <div className=" flex justify-between mb-3 text-sm">
              <p className=" text-gray-6">تعیین سطح کیفیت محصول</p>
              <span
                className="icon-close text-gray-6 "
                onClick={() => {
                  setIsOpenGrade(false);
                  setIsChecked(false);
                }}
              ></span>
            </div>
            <p className=" text-gray-6 text-justify mb-3 text-sm">
              با پاسخ به چند سوال، درجه کیفیت محصول شما ارزیابی شده و در آگهی
              نمایش داده می‌شود.
            </p>
            <Grade
              questions={questions}
              handleAnswers={handleAnswers}
              setIsOpenGrade={setIsOpenGrade}
              handleGradeAnswer={handleGradeAnswer}
              answers={answers}
            />
          </>
        </CustomBottomSheet>
      )}

      {isOpenGradeAnswer && (
        <>
          <CustomBottomSheet
            isOpen={isOpenGradeAnswer}
            onDismiss={() => setIsOpenGradeAnswer(false)}
          >
            <div>
              <img src={Quality} alt="quality" className="block mx-auto my-3" />
              <p>
                سطح کیفیت محصول شما :{' '}
                <span
                  className={classNames(
                    ' mt-6 py-0.5 px-2 rounded-full',
                    Number(grade) === 1 && ' bg-warning-1 text-warning-2',
                    Number(grade) === 2 && ' bg-natural-3 text-natural-4',
                    Number(grade) === 3 && ' bg-error-1 text-warning-2',
                    Number(grade) > 3 && ' bg-Cyan-chat-6 text-green-grade',
                  )}
                >
                  درجه {qualityConvertor[grade]}
                </span>{' '}
                می باشد.
              </p>
              <button
                className=" text-white bg-green-1 py-4 text-center w-full rounded-md my-3"
                onClick={() => setIsOpenGradeAnswer(false)}
              >
                متوجه شدم
              </button>
            </div>
          </CustomBottomSheet>
        </>
      )}
    </>
  );
};

export default AuctionFormComponent;
